import { BackofficeUsersSetupInterface } from '../../../../../interfaces/dto/backoffice-users/backoffice-users-setup/backoffice-users-setup-interface';

export class BackofficeUsersSetupModel implements BackofficeUsersSetupInterface {
  profiles: Array<any> = new Array<any>();
}
